(() => {
  angular
    .module('complianceFrameworkApp.complianceFramework')
    .controller('EditBannerController', EditBannerController);

  /* ngInject */
  function EditBannerController($state, $stateParams, $timeout, Flash, bannerService, config, formErrorsService, sessionService, Upload) {
    const vm = this;

    angular.extend(vm, formErrorsService);

    vm.banner = {};
    vm.bannerForm = {};
    vm.config = config;
    vm.deleteBanner = deleteBanner;
    vm.deleteImage = deleteImage;
    vm.getBanner = getBanner;
    vm.updateBanner = updateBanner;
    vm.uploadImage = uploadImage;

    activate();

    function activate() {
      getBanner();
    }

    function deleteBanner() {
      angular.element('#deleteBannerModal').modal('hide');
      vm.clearFormErrors(vm.bannerForm);
      bannerService(sessionService.getAuthToken()).destroy({id: $stateParams.bannerId});
      $state.go('application.compliance_framework.banners');
      Flash.create('success', 'Banner was sucessfully deleted.');
    }

    function deleteImage() {
      bannerService(sessionService.getAuthToken()).removeImage({id: vm.banner.id}, _removeImageSuccess, _removeImageFailure);
    }

    function getBanner() {
      bannerService(sessionService.getAuthToken()).get({id: $stateParams.bannerId}, response => vm.banner = response);
    }

    function updateBanner() {
      vm.clearFormErrors(vm.bannerForm);
      bannerService(sessionService.getAuthToken()).update({id: vm.banner.id}, vm.banner, _updateBannerSuccess, _updateBannerFailure);
    }

    function uploadImage(image) {
      image.upload = Upload.upload({
        url: `${config.complianceFrameworkApiEndpoint}/api/banners/${vm.banner.id}/image`,
        method: 'POST',
        data: {image: image},
        headers: {
          'Authorization': `Token token=${sessionService.getAuthToken()}`
        }
      });

      image.upload.then(response => {
        $timeout(() => {
          vm.banner = response.data;
          Flash.create('success', 'Image successfully updated.');
        });
      }, _response => {
        Flash.create('danger', 'An unexpected error occurred uploading image.');
      });
    }

    function _removeImageSuccess(response) {
      Flash.create('success', 'Image successfully removed.');
      vm.banner.image_url = response.image_url;
    }

    function _removeImageFailure(error) {
      Flash.create('danger', 'An error occurred deleting the image.');
      vm.setFormErrors(vm.bannerForm, error);
    }

    function _updateBannerSuccess(_response) {
      Flash.create('success', 'Banner was sucessfully updated.');
      $state.go('application.compliance_framework.banners');
    }

    function _updateBannerFailure(error) {
      Flash.create('danger', 'An error occurred with the submission. Please correct the following errors on the form and resubmit.');
      vm.setFormErrors(vm.bannerForm, error);
    }
  }
})();
